import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useRef } from 'react';
import { createPortal } from 'react-dom';
import TripBuilderGetPdfContent from './TripBuilderGetPdfContent';
import TripBuilderGetPdfStyles from './TripBuilderGetPdfStyles';
import TripBuilderShareActions from './TripBuilderShareActions';
import { ProposalData } from 'ts/shared/interfaces/ProposalData';
import { TripPreviewModel } from 'utils/shared/tripResultBuilderPreview';
import ScreenshotSupport from '../../ScreenshotSupport';
import Button from 'components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import { i18nTB } from 'utils/shared/utils';
import TripBuilderGetPdfStylesV2 from './TripBuilderGetPdfStylesV2';
import { getActiveTripPreviewHotelNames } from 'utils/shared/tripBuilderClientSummary';



interface TripBuilderGetPdfModalProps {
  close: () => void;
  proposalId: string;
  proposal: ProposalData;
  model: TripPreviewModel;
  selectedRoomByHotel: Record<string, number>;
  hidePrices?: boolean;
  hotelImageBySlot?: Record<string, string>;
  uiVersion?: 1 | 2;
}

const TripBuilderGetPdfModal: FC<TripBuilderGetPdfModalProps> = ({
  close,
  proposalId,
  proposal,
  model,
  selectedRoomByHotel,
  hidePrices,
  hotelImageBySlot,
  uiVersion = 1,
}) => {
  const { t, i18n } = useTranslation(undefined, { i18n: i18nTB });
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <Fragment>
      <TripBuilderGetPdfStyles />
      {uiVersion === 2 && <TripBuilderGetPdfStylesV2 />}
      {createPortal(
        <div className="modal-overlay modal-overlay-top">
          <div className="modal active tbp-modal" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
            <div className="modal-title">
              <div className="title">{t('your_itinerary')}</div>
              <div>
                <ScreenshotSupport />
                <FontAwesomeIcon icon={faTimes} onClick={close} />
              </div>
            </div>
            <div className="modal-content" ref={contentRef}>
              <TripBuilderGetPdfContent
                model={model}
                proposal={proposal}
                selectedRoomByHotel={selectedRoomByHotel}
                hidePrices={hidePrices}
                hotelImageBySlot={hotelImageBySlot}
                uiVersion={uiVersion}
              />
            </div>
            <div className="modal-footer" >
              <TripBuilderShareActions
                proposalId={proposalId}
                pdfContainerRef={contentRef}
                plain
                hotelNames={getActiveTripPreviewHotelNames(model)}
              />
              <Button title={t('close')} onClick={close} className="btn btn-default btn-sm" />
            </div>
          </div>
        </div>,
        document.body,
      )}
    </Fragment>
  );
};

export default TripBuilderGetPdfModal;
